<template>
    <div>
        <el-card>
            <div class="title" >总部详情</div>
            <el-table  :data="data" border stripe v-loading="loading" >
                <el-table-column type="index"></el-table-column>
                <el-table-column label="总部名" prop="name" ></el-table-column>
                <el-table-column label="服务费率(单位万分之)" prop="serv_rate" ></el-table-column>
                <el-table-column label="支付宝账户" prop="ali_logon_id" ></el-table-column>
                <el-table-column label="支付宝真实名" prop="ali_name" ></el-table-column>
                <el-table-column label="创建时间" prop="create_time" >
                    <template slot-scope="scope">{{scope.row.create_time | dataFormat }}</template>
                </el-table-column>
                <el-table-column label="更新时间" prop="update_time" >
                    <template slot-scope="scope">{{scope.row.update_time | dataFormat }}</template>
                </el-table-column>
                <el-table-column label="操作" width="150px">
                    <template slot-scope="scope">
                        <el-button type="primary" icon="el-icon-s-tools" size="mini"  @click="edit">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <Input  :labels="message" @confirm="Todo" @cancel="Cancel" v-if="isTodo"></Input>

    </div>
</template>

<script>
    import Input from "../input"

    export default {
        name: "head_detail",
        created () {
            this.id = this.$route.params.id
            this.fetchData();
            this.initData();
        },
        components:{
            Input
        },
        data(){
            return{
                id:"",
                loading:false,
                data:[],
                isTodo:false,
                message:[
                    {
                        key: "name",
                        name: "总部名称",
                        type: "normal"
                    },
                   {
                    key:"cate",
                    name:"类别",
                    type:"idoption",
                    value:3,
                    options:[
                      {value:"serv_agent",label:"服务商"},
                      {value:"",label:"无"}
                    ]
                    },
                    /*{
                        key: "serv_rate",
                        name: "服务费率(单位万分之)",
                        type: "num"
                    },*/
                    {
                      key: "serv_isv_rate",
                      name: "ISV费率(单位万分之)",
                      type: "num"
                    },
                    {
                      key: "serv_agent_rate",
                      name: "服务商费率(单位万分之)",
                      type: "num"
                    },
                    {
                      key: "serv_rate",
                      key1:"serv_isv_rate",
                      key2:"serv_agent_rate",
                      name: "服务费率(单位万分之)",
                      type: "num2"
                    },
                    {
                      key: "ali_logon_id",
                      name: "支付宝账户",
                      type: "normal"
                    },
                    {
                      key: "ali_name",
                      name: "支付宝真实名称",
                      type: "normal"
                    },
                    {
                      key: "icon_url",
                      name: "头像",
                      type: "Imgupload"
                    },
                    {
                      key: "serv_agent_head_id",
                      name: "服务商(选填)",
                      type: "idoption2",
                      _oper: "get_multi",
                      _ent: "head",
                      _param: "name",
                      _param_cate:"serv_agent",
                      options:[],
                      selectObj:{id:0,name:""}
                    },
                    {
                      key: "hr_account_id",
                      name: "HR(选填)",
                      type: "idoption2",
                      _oper: "get_multi",
                      _ent: "account",
                      _param: "name",
                      _param_cate:"hr",
                      options:[],
                      selectObj:{id:0,name:""}
                    }
                ]
            }
        },
        methods:{
          async initData(){
            const {data: res} = await this.$http.post('',
                {
                  "oper": "get_multi",
                  "ent": "head",
                  "info": {
                  }
                }
            )
            console.log(res)
            if(res.code ==0){
               this.message[2].idoptions=res.data;
            }

            const {data: res1} = await this.$http.post('',
                {
                  "oper": "get_multi",
                  "ent": "account",
                  "info": {
                  }
                }
            )
            console.log(res1)
            if(res1.code ==0){
              this.message[3].idoptions=res1.data;
            }

          },
          //详情
          async fetchData () {
              this.loading = true
              const {data: res} = await this.$http.post('',
                  {
                      "oper": "get_by_id",
                      "ent": "head",
                      "info": {
                          "id": this.id
                      }
                  }
              )

              console.log(res)
              if(res.code !=0){
                  this.$message({
                      message:res.msg,
                      duration:6000
                  });;
              }
              for(let i of this.message){
                i["value"]=res.data[i["key"]]
                if(i["key"]=="serv_agent_head_id" && i["value"]>0){
                   const selected ={
                     name:res.data["serv_agent_info"]["name"],
                     id:i["value"]
                   }
                  i["selectObj"]=selected;
                  i["options"].push(selected);
                }

                if(i["key"]=="hr_account_id" && i["value"]>0){
                  const selected ={
                    name:res.data["hr_account_info"]["name"],
                    id:i["value"]
                  }
                  i["selectObj"]=selected;
                  i["options"].push(selected);
                }
              }
              this.data.length = 0;
              this.data.push(res.data);
              this.loading=false;
          },
          edit() {
              this.isTodo=true;
          },
          async Todo(val){
              val["id"]=parseInt(this.id);
              const { data: res } = await this.$http.post('',
                  {
                      "oper": "edit",
                      "ent": "head",
                      "info": val
                  }
              )
              console.log(res)
              if(res.code==0){
                  this.$message("操作成功");
                  this.fetchData();
                  this.isTodo=false;
              }
              else{
                  this.$message({
                      message:res.msg,
                      duration:6000
                  });;
              }
          },
          Cancel(){
              this.isTodo=false;
          },
        }
    }
</script>

<style scoped>

</style>
